define('common/module/date/Serum.Clock',[
  'jquery',
  'common/js/lib/Serum.Pubsub',
  'common/js/lib/Serum.Time',
  'common/js/lib/Serum.Moment'
], function($, Pubsub, SerumTime, moment) {
  'use strict';

  function tick($element) {
    var now = moment(SerumTime.now());
    $element.html(now.format('HH:mm:ss'));
    $element.attr('datetime', now.toISOString());
  }

  function initialize($element) {
    if($element.length) {
      Pubsub.subscribe(Pubsub.topics.TIME_EVENT, function() {
        setInterval(function(){
          tick($element);
        }, 1000);
        tick($element);
      });

      SerumTime.initialize();
    }
  }

  return {
    initialize: initialize
  }

});

